import { proxy } from 'valtio';

/**
 * State for the article settings component.
 *
 * Currently only tracks if the category dropdown has been touched.
 */
export type State = {
  categoryTouched: boolean;
};

const initialState: State = {
  categoryTouched: false,
};

export const articleSettingsState = proxy<State>(initialState);

export const articleSettingsActions = {
  blurCategoryDropdown(): void {
    articleSettingsState.categoryTouched = true;
  },
};
